// ABOUTME: Track & trace email template view on the relation Email settings page.
// ABOUTME: Thin wrapper around the shared EmailTemplateEditor with saleschannel scoping and shipment preview.

import EmailTemplateEditor from "../../../../../components/global/EmailTemplates/EmailTemplateEditor";
import { UserPrivileges } from "../../../../../utils/permissions";

const TrackAndTrace = (props) => (
    <EmailTemplateEditor
        {...props}
        type="trackandtrace"
        titleKey="trackandtrace_email"
        managePrivileges={[UserPrivileges.RP_COMPANY_INFO_MANAGE]}
        enableChannels
        enableShipmentPreview
        showSubject
    />
);

export default TrackAndTrace;
